<div class="card">
  <div class="card-header p-4">
    <h3>{{ cardTitle$ | async }}</h3>
  </div>
  <div class="card-body discovered-scannable-documents">
    <div class="row">
      <div class="col">
        @if (isMonitoringScan$.value) {
          <p class="filename">{{ ('upload_file_name' | translate) + ': ' + title }}</p>
        }
        <p class="found-during-automated-scan">{{ foundDuringText$ | async }}</p>
      </div>
      <div class="col-md-auto mb-2">
        @if (hasUploadDocumentPermission$ | async) {
          <button type="button" class="btn btn-primary upload" (click)="upload()" [disabled]="!canUpload">
            {{ 'upload_for_testing' | translate }}
          </button>
        }
      </div>
    </div>

    <p class="discovered-on-the-following-pages">{{ 'discovered-on-the-following-pages' | translate }}</p>
    @if (foundInPages) {
      <ul class="found-in-pages-list p-0">
        @for (page of foundInPages; track page) {
          <li class="found-in-pages-list-item mb-2">
            <a class="page-url" [href]="page">
              {{ page }}
            </a>
          </li>
        }
      </ul>
    }
  </div>
</div>
